import React, { Suspense } from "react";
import { createBrowserRouter, RouterProvider, useRouteError } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Welcome from "./main/main";
import Register from "./register/register";


const Login = React.lazy(() => import("./login/login").then(m => ({ default: m.App })));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const ServiceDetails = React.lazy(() => import("./pages/ServiceDetails"));
const Profile = React.lazy(() => import("./pages/Profile"));

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">Cargando...</div>
);

// Pantalla de error a nivel de ruta. Reemplaza la pantalla de desarrollo que
// trae React Router (la que el usuario vio: "Unexpected Application Error!").
// La causa más común de un fallo de render en producción es la traducción
// automática del navegador mutando el DOM, así que lo sugerimos explícitamente.
function RouteErrorScreen() {
  const error = useRouteError() as unknown;

  console.error("Error capturado por RouteErrorScreen:", error);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <div className="max-w-md w-full text-center">
        <h1 className="text-xl font-semibold text-gray-900">Algo salió mal</h1>
        <p className="mt-2 text-sm text-gray-600">
          Ocurrió un error inesperado al cargar esta página. Si tienes activada la
          traducción automática del navegador, desactívala para este sitio y vuelve
          a intentarlo.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-6 inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Recargar página
        </button>
      </div>
    </div>
  );
}

// Route configuration
const routeConfig = [
  {
    path: "/",
    element: <Welcome />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/registro",
    element: <Register />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/service/:serviceId",
    element: (
      <ProtectedRoute>
        <ServiceDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path:"/regsucess",
    element:<Welcome/>
  },
  {
    path: "*",
    element: <Welcome />,
  },
] satisfies Array<{ path: string; element: React.ReactNode }>;

// Ruta padre sin path: su `errorElement` captura los errores de render que
// burbujean desde cualquier ruta hija (incluidos los de la fase de commit de
// React, como el NotFoundError de removeChild).
const router = createBrowserRouter([
  {
    errorElement: <RouteErrorScreen />,
    children: routeConfig,
  },
]);

export default function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
